import "./AddUsers.scss";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import checkMark from "../../assets/images/icons/check-mark.svg";
import addPhoto from "../../assets/images/icons/add-photo.svg";
import chevronDown from "../../assets/images/icons/chevron-down.svg";
import calendar from "../../assets/images/icons/calendar.svg";

import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Calendar from "react-calendar";
import "../../styles/CalendarStyles.css";

import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function AddUsers() {
    const navigate = useNavigate();

    const [showGenderDropdown, setShowGenderDropdown] = useState(false);

    //HANDING CLICK OUTS ==============================================================================

    const componentRef = useRef(null);
    const calendarRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target)) {
                setShowGenderDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [newFirstName, setNewFirstName] = useState("");
    const [newLastName, setNewLastName] = useState("");
    const [newGender, setNewGender] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [newBday, setNewBday] = useState("");
    const [newPhoneNum, setNewPhoneNum] = useState("");
    const [newIGHandle, setNewIGHandle] = useState("");
    const [newLocation, setNewLocation] = useState("");
    const [profilePic, setProfilePic] = useState(null);

    async function handleAddUserSubmit(event) {
        event.preventDefault();

        const newUser = {
            id: uuidv4(),
            created: new Date(),
            firstName: newFirstName,
            lastName: newLastName,
            gender: newGender,
            bday: formatDate(newBday),
            location: newLocation,
            email: newEmail,
            phone: newPhoneNum,
            ig: newIGHandle,
        };

        try {
            await axios.post(`https://zona-app-server-584d567d8841.herokuapp.com/users`, newUser);
            navigate("/users");
        } catch (err) {
            console.log(`error adding user. this was the error: ${err}`);
        }
    }

    const fileInputRef = useRef(null);

    const handleFileUpload = () => {
        const something = fileInputRef.current.click();
        console.log("this is what happens when i upload a file: ", something);
    };

    //HANDLE CALENDAR ============================================================

    const [newEventDate, setNewEventDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    // Format the selected date to DD/MM/YYYY
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date),
            day = "" + d.getDate(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();

        return [day.padStart(2, "0"), month.padStart(2, "0"), year].join("/");
    };

    const handleDateChange = (nextValue) => {
        setNewBday(nextValue);
        setShowCalendar(false); // Hide the calendar after a date is selected
    };

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="add-user">
                        <div className="add-user__top">
                            <Link to="/users">
                                <img className="add-user__top-icon" src={chevronLeft} alt="chevron pointing left"></img>
                            </Link>
                            <h1 className="add-user__top-heading">Adding new user</h1>
                        </div>

                        <form onSubmit={handleAddUserSubmit} className="add-user__form">
                            <section className="edit-event__form--left">
                                <div className="add-user__form-first">
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="firstName" className="add-user__form-first-field-label">
                                            First Name
                                        </label>
                                        <input
                                            className="add-user__form-first-field-input"
                                            id="firstName"
                                            name="firstName"
                                            type="text"
                                            value={newFirstName}
                                            onChange={(event) => setNewFirstName(event.target.value)}
                                            placeholder="Enter first name"
                                            required
                                        />
                                    </div>
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="lastName" className="add-user__form-first-field-label">
                                            Last Name
                                        </label>
                                        <input
                                            id="lastName"
                                            className="add-user__form-first-field-input"
                                            name="lastName"
                                            type="text"
                                            value={newLastName}
                                            onChange={(event) => setNewLastName(event.target.value)}
                                            placeholder="Enter last name"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-user__form-first">
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="eventDate" className="edit-event__form-block-group-label">
                                            Date
                                        </label>
                                        <div className="edit-event__form-block-group-container">
                                            <input
                                                type="text"
                                                id="eventDate"
                                                name="eventDate"
                                                placeholder="DD/MM/YYYY"
                                                className="edit-event__form-block-group-input"
                                                value={newBday ? formatDate(newBday) : ""}
                                                onChange={(event) => setNewBday(event.target.value)}
                                                onFocus={() => setShowCalendar(true)}
                                                required
                                            />
                                            <img
                                                src={calendar}
                                                alt="calendar button"
                                                className="edit-event__form-block-group-container--calendar"
                                                onClick={() => setShowCalendar(true)}
                                            />
                                        </div>
                                        <div className="edit-user__form-first-field-input-calendar">
                                            {showCalendar && (
                                                <Calendar
                                                    onChange={handleDateChange}
                                                    value={newEventDate}
                                                    next2Label={null}
                                                    prev2Label={null}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="add-user__form-first-field">
                                        <label htmlFor="gender" className="add-user__form-first-field-label">
                                            Gender
                                        </label>
                                        <div ref={componentRef}>
                                            <div
                                                onClick={() => setShowGenderDropdown(!showGenderDropdown)}
                                                className="add-user__form-first-field-input add-user__form-first-field-input--special"
                                            >
                                                <p className="add-user__form-first-field-input-text">
                                                    {newGender ? newGender : "Select gender"}
                                                </p>
                                                <img
                                                    className="add-user__form-first-field-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showGenderDropdown && (
                                                <Dropdown
                                                    type={"radio"}
                                                    data={["Male", "Female", "Non-binary", "Prefer not to answer"]}
                                                    setter={setNewGender}
                                                    valueSet={newGender}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="add-user__form-first">
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="email" className="add-user__form-first-field-label">
                                            E-mail
                                        </label>
                                        <input
                                            className="add-user__form-first-field-input"
                                            id="email"
                                            name="email"
                                            type="email"
                                            value={newEmail}
                                            onChange={(event) => setNewEmail(event.target.value)}
                                            placeholder="Enter e-mail"
                                            required
                                        />
                                    </div>
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="phoneNum" className="add-user__form-first-field-label">
                                            Phone
                                        </label>
                                        <input
                                            className="add-user__form-first-field-input"
                                            id="phoneNum"
                                            name="phoneNum"
                                            type="text"
                                            value={newPhoneNum}
                                            onChange={(event) => setNewPhoneNum(event.target.value)}
                                            placeholder="Enter phone"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-user__form-first">
                                    <div className="add-user__form-first-field">
                                        <label htmlFor="location" className="add-user__form-first-field-label">
                                            Location
                                        </label>
                                        <input
                                            className="add-user__form-first-field-input"
                                            id="location"
                                            name="location"
                                            type="text"
                                            value={newLocation}
                                            onChange={(event) => setNewLocation(event.target.value)}
                                            placeholder="Enter location"
                                        />
                                    </div>

                                    <div className="add-user__form-first-field">
                                        <label htmlFor="igTag" className="add-user__form-first-field-label">
                                            Instagram
                                        </label>
                                        <input
                                            className="add-user__form-first-field-input"
                                            id="igTag"
                                            name="igTag"
                                            type="text"
                                            value={newIGHandle}
                                            onChange={(event) => setNewIGHandle(event.target.value)}
                                            placeholder="Enter Instagram name"
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="add-user__form-button">
                                    <p className="add-user__form-button-text">Save Information</p>
                                    <img src={checkMark} alt="a checkmark"></img>
                                </button>
                            </section>

                            <section className="add-user__form--right">
                                <div className="add-user__form-photo">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(event) => setProfilePic(event.target.files[0])}
                                    />
                                    <button
                                        type="button"
                                        className="add-user__form-photo-button"
                                        onClick={handleFileUpload}
                                    >
                                        <img src={addPhoto} alt="click here to upload a file"></img>
                                    </button>
                                </div>
                            </section>
                        </form>
                    </section>
                </article>
            </div>
        </main>
    );
}

export default AddUsers;
